<template>
    <v-container pa-0>
        <!-- change retailer step 3 - confirmation -->
        <v-card class="px-2 pt-2 pb-6 mt-3" flat tile>
            <v-card-title class="headline font-weight-bold pa-2">
                {{ $vuetify.lang.t('$vuetify.change_retailer.completed_headline') }}
            </v-card-title>
            <div class="px-2 mb-5 body-1" v-html="$vuetify.lang.t('$vuetify.change_retailer.completed_description')"></div>

            <v-alert type="success"
                     class="mx-2"
                     icon="mdi-logout-variant"
                     text
                     border="left">
                {{ $vuetify.lang.t('$vuetify.change_retailer.completed_loggedout') }}
            </v-alert>


            <!-- submit-button -->
            <div class="d-flex justify-center">
                <v-btn color="primary darken-1" :to="urlToLogin">
                    {{ $vuetify.lang.t(`$vuetify.buttons.back_to_login`) }}
                </v-btn>
            </div>

        </v-card>
        <!-- /change retailer step 3 - confirmation -->
    </v-container>
</template>
<script>
    // utils
    import {
        setPageTitle,
    } from '../../utils/helper';
    import { ROUTE_LOGIN } from "../../utils/constants";
    export default {
        name: 'change-retailer-success',
        computed: {
            urlToLogin() {
                return { name: ROUTE_LOGIN };
            },
        },
    }
</script>
